import React, { useState, useEffect } from 'react';

// import './FormGroup.css';
// import RangeSlider from '../RangeSlider/RangeSlider';
import NumberInput from '../NumberInput/NumberInput';
import RangeSlider from '../RangeSlider/RangeSlider';
import RangerWrapper from '../RangeSlider/RangerWrapper';
import Label from '../RangeSlider/Label';
import Ranger from '../RangeSlider/Ranger';
import MinMax from '../RangeSlider/MinMax';
import HelperText from '../RangeSlider/HelperText';
// import AirfareSimple from '../Airfare/AirfareSimple';
import ResultAnalyticalB from '../Result/ResultAnalyticalB';
import ResultData from '../Result/ResultData';
import EmailToYourself from './EmailToYourself';
import SendEmail from './SendEmail';


function FormGroup(props) {
    // create state variables for the input values
    const [people, setPeople] = useState(1);
    const [nights, setNights] = useState(1);

    const [airfare, setAirfare] = useState(595);
    const [lodging, setLodging] = useState(0);
    const [food, setFood] = useState(0);
    const [transport, setTransport] = useState(0);
    const [entertainment, setEntertainment] = useState(0);
    const [tips, setTips] = useState(0);
    const [major, setMajor] = useState(0);
    const [slush, setSlush] = useState(props.slushDefault);

    useEffect(() => {
        if (props.lodgingDefault) {
            setLodging(props.lodgingDefault);
        }
    }, [props.lodgingDefault]);

    useEffect(() => {
        if (props.foodBeverageDefault) {
            setFood(props.foodBeverageDefault);
        }
    }, [props.foodBeverageDefault]);

    useEffect(() => {
        if (props.localTransDefault) {
            setTransport(props.localTransDefault);
        }
    }, [props.localTransDefault]);

    useEffect(() => {
        if (props.entertainmentDefault) {
            setEntertainment(props.entertainmentDefault);
        }
    }, [props.entertainmentDefault]);

    useEffect(() => {
        if (props.tipsDefault) {
            setTips(props.tipsDefault);
        }
    }, [props.tipsDefault]);

    useEffect(() => {
        if (props.slushDefault) {
            setSlush(props.slushDefault);
        }
    }, [props.slushDefault]);


    // handle the onChange event for the input components
    const handlePeopleChange = (newValue) => { setPeople(parseInt(newValue)); };
    const handleNightsChange = (newValue) => { setNights(parseInt(newValue)); };

    const handleAirfareChange = (newValue) => { setAirfare(parseInt(newValue)); };
    const handleLodgingChange = (newValue) => { setLodging(parseInt(newValue)); };
    const handleFoodChange = (newValue) => { setFood(parseInt(newValue)); };
    const handleTransportChange = (newValue) => { setTransport(parseInt(newValue)); };
    const handleEntertainmentChange = (newValue) => { setEntertainment(parseInt(newValue)); };
    const handleTipsChange = (newValue) => { setTips(parseInt(newValue)); };
    const handleMajorChange = (newValue) => { setMajor(parseInt(newValue)); };
    const handleSlushChange = (newValue) => { setSlush(parseInt(newValue)); };

    const resAirfare = people * airfare;
    const resLodging = people * nights * lodging;
    const resFood = people * nights * food;
    const resTrans = people * nights * transport;
    const resEnter = people * nights * entertainment;
    const resTips = nights * tips;
    const resMajor = people * major;

    const resultWithoutSlush = (people * airfare) +
        (people * nights * lodging) +
        (people * nights * food) +
        (people * nights * transport) +
        (people * nights * entertainment) +
        (nights * tips) +
        (people * major)

    const slushCost = Math.ceil(resultWithoutSlush * slush / 100);

    // perform the calculations using the input values
    const result = Math.ceil(resultWithoutSlush * (1 + slush / 100));

    const [isChecked, setIsChecked] = useState(true);
    const handleCheckboxChange = (evt) => {
        setIsChecked(evt.target.checked);
    }

    return (
        <div className="form-container">
            <div className='section-container'>
                <p className=''>The numbers below are based on averages for the destination and travel style you chose. Use the sliders to adjust them based on what you know about yourself, your group and your trip.</p>
                <ul className='text-list'>
                    <li>Do you like to visit 6 museums each day, or will you be sitting on a park bench watching people go by?</li>
                    <li>Will you be in a tourist hotspot, or are you headed to a remote village?</li>
                    <li>Are you a foodie who likes to dine out for every meal, or will you be cooking?</li>
                    <li>Have you signed up for an expensive tour or event?</li>
                </ul>
            </div>
            <div className='result-sticky-container'>
                {props.country ? (
                    <span className='inline-block p-5 rounded-md bg-sky-100 shadow-lg'>{props.country}, trip budget: ${result}</span>
                ) : ''}
            </div>
            <div className='fields-container'>
                <NumberInput
                    type="number"
                    title='people'
                    description='How many people are going on this trip?'
                    unit=""
                    symbol=""
                    helpTxt=''
                    value={people}
                    min={1}
                    max={500}
                    minMaxShow={0}
                    step={1}
                    required={1}
                    onChange={handlePeopleChange} />
                <NumberInput
                    type="number"
                    title='nights'
                    description='How many nights will you sleep at your destination? *'
                    unit=""
                    symbol=""
                    helpTxt=''
                    value={nights}
                    min={1}
                    max={365}
                    minMaxShow={0}
                    step={1}
                    required={1}
                    onChange={handleNightsChange} />
            </div>
            <RangeSlider
                type="range"
                title='airfare'
                description='Round-trip airfare per person'
                unit="per Person"
                symbol="$"
                helpTxt=''
                value={airfare}
                min={100}
                max={3000}
                minMaxShow={1}
                step={1}
                onChange={handleAirfareChange}>
                {/* <AirfareSimple /> */}
            </RangeSlider>

            <RangeSlider
                type="range"
                title='lodging'
                description='Nightly lodging cost per person'
                unit="per person per day"
                symbol="$"
                helpTxt=''
                value={lodging}
                min={0}
                max={1000}
                minMaxShow={1}
                step={1}
                onChange={handleLodgingChange} />
            <RangeSlider
                type="range"
                title='food'
                description='Daily food & beverage per person per day'
                unit="per person per day"
                symbol="$"
                helpTxt='Include drinking water, alcohol, coffee, etc.'
                value={food}
                min={0}
                max={150}
                minMaxShow={1}
                step={1}
                onChange={handleFoodChange} />
            <RangeSlider
                type="range"
                title='transportation'
                description='Daily ground transportation per person'
                unit="per person per day"
                symbol="$"
                helpTxt='Taxis, public transport, car rental, ferries, etc.'
                value={transport}
                min={0}
                max={100}
                minMaxShow={1}
                step={1}
                onChange={handleTransportChange} />
            <RangeSlider
                type="range"
                title='entertainment'
                description='Daily entertainment per person'
                unit="per day"
                symbol="$"
                helpTxt='Museums, attractions, tours, shows, clubs, etc.'
                value={entertainment}
                min={0}
                max={100}
                minMaxShow={1}
                step={1}
                onChange={handleEntertainmentChange} />
            <RangeSlider
                type="range"
                title='tips'
                description='Tips & gratuties per day'
                unit="per day"
                symbol="$"
                helpTxt=''
                value={tips}
                min={0}
                max={204}
                minMaxShow={1}
                step={1}
                onChange={handleTipsChange} />
            <RangeSlider
                type="range"
                title='major'
                description='Major expenses per person'
                unit="per person"
                symbol="$"
                helpTxt='If your trip includes an expensive tour, activity, or side trip, include that here.'
                value={major}
                min={0}
                max={20000}
                minMaxShow={1}
                step={25}
                onChange={handleMajorChange} />
            <RangerWrapper>
                <Label title='slush'>
                    <span className="title">Slush Fund</span>
                    <span className="unit">+ {slush}% per trip</span>
                </Label>
                <Ranger
                    title='slush'
                    value={slush}
                    min={0}
                    max={100}
                    minMaxShow={1}
                    step={1}
                    onChange={handleSlushChange}
                />
                <MinMax>
                    <span>0%</span>
                    <span>100%</span>
                </MinMax>
                <HelperText>
                    <p>It's always a good idea to add 10-20% to your total budget for wiggle room</p>
                </HelperText>
            </RangerWrapper>
            <ResultAnalyticalB>
                <ResultData className="col col-8 md:col-6 highlight">Expense</ResultData>
                <ResultData className="col col-h md:col-b md:col-2 text-right  highlight">Cost</ResultData>
                <ResultData className="col col-h md:col-b md:col-1 text-center highlight">×</ResultData>
                <ResultData className="col col-h md:col-b md:col-2 text-center highlight">Person(s)</ResultData>
                <ResultData className="col col-h md:col-b md:col-1 text-center highlight">×</ResultData>
                <ResultData className="col col-h md:col-b md:col-1 text-center highlight">Day(s)</ResultData>
                <ResultData className="col col-h md:col-b md:col-1 text-center highlight">=</ResultData>
                <ResultData className="col col-8 text-right md:col-2 highlight">SubTotal</ResultData>

                <ResultData className="col col-8 md:col-6">Airfare</ResultData>
                <ResultData className="col col-h md:col-b md:col-2 text-right">${airfare}</ResultData>
                <ResultData className="col col-h md:col-b md:col-1 text-center">×</ResultData>
                <ResultData className="col col-h md:col-b md:col-2 text-center">{people}</ResultData>
                <ResultData className="col col-h md:col-b md:col-1 text-center">×</ResultData>
                <ResultData className="col col-h md:col-b md:col-1 text-center"></ResultData>
                <ResultData className="col col-h md:col-b md:col-1 text-center">=</ResultData>
                <ResultData className="col col-8 text-right md:col-2">${people * airfare}</ResultData>

                <ResultData className="col col-8 md:col-6">Nightly Lodging Cost</ResultData>
                <ResultData className="col col-h md:col-b md:col-2 text-right">${lodging}</ResultData>
                <ResultData className="col col-h md:col-b md:col-1 text-center">×</ResultData>
                <ResultData className="col col-h md:col-b md:col-2 text-center">{people}</ResultData>
                <ResultData className="col col-h md:col-b md:col-1 text-center">×</ResultData>
                <ResultData className="col col-h md:col-b md:col-1 text-center">{nights}</ResultData>
                <ResultData className="col col-h md:col-b md:col-1 text-center">=</ResultData>
                <ResultData className="col col-8 text-right md:col-2">${people * nights * lodging}</ResultData>

                <ResultData className="col col-8 md:col-6">Daily Food & Beverage Per Person</ResultData>
                <ResultData className="col col-h md:col-b md:col-2 text-right">${food}</ResultData>
                <ResultData className="col col-h md:col-b md:col-1 text-center">×</ResultData>
                <ResultData className="col col-h md:col-b md:col-2 text-center">{people}</ResultData>
                <ResultData className="col col-h md:col-b md:col-1 text-center">×</ResultData>
                <ResultData className="col col-h md:col-b md:col-1 text-center">{nights}</ResultData>
                <ResultData className="col col-h md:col-b md:col-1 text-center">=</ResultData>
                <ResultData className="col col-8 text-right md:col-2">${people * nights * food}</ResultData>

                <ResultData className="col col-8 md:col-6">Daily Ground Transportation</ResultData>
                <ResultData className="col col-h md:col-b md:col-2 text-right">${transport}</ResultData>
                <ResultData className="col col-h md:col-b md:col-1 text-center">×</ResultData>
                <ResultData className="col col-h md:col-b md:col-2 text-center">{people}</ResultData>
                <ResultData className="col col-h md:col-b md:col-1 text-center">×</ResultData>
                <ResultData className="col col-h md:col-b md:col-1 text-center">{nights}</ResultData>
                <ResultData className="col col-h md:col-b md:col-1 text-center">=</ResultData>
                <ResultData className="col col-8 text-right md:col-2">${people * nights * transport}</ResultData>

                <ResultData className="col col-8 md:col-6">Daily Entertainment Per Person</ResultData>
                <ResultData className="col col-h md:col-b md:col-2 text-right">${entertainment}</ResultData>
                <ResultData className="col col-h md:col-b md:col-1 text-center">×</ResultData>
                <ResultData className="col col-h md:col-b md:col-2 text-center">{people}</ResultData>
                <ResultData className="col col-h md:col-b md:col-1 text-center">×</ResultData>
                <ResultData className="col col-h md:col-b md:col-1 text-center">{nights}</ResultData>
                <ResultData className="col col-h md:col-b md:col-1 text-center">=</ResultData>
                <ResultData className="col col-8 text-right md:col-2">${people * nights * entertainment}</ResultData>

                <ResultData className="col col-8 md:col-6">Tips & Gratuties Per Day	</ResultData>
                <ResultData className="col col-h md:col-b md:col-2 text-right">${tips}</ResultData>
                <ResultData className="col col-h md:col-b md:col-1 text-center">×</ResultData>
                <ResultData className="col col-h md:col-b md:col-2 text-center"></ResultData>
                <ResultData className="col col-h md:col-b md:col-1 text-center">×</ResultData>
                <ResultData className="col col-h md:col-b md:col-1 text-center">{nights}</ResultData>
                <ResultData className="col col-h md:col-b md:col-1 text-center">=</ResultData>
                <ResultData className="col col-8 text-right md:col-2">${nights * tips}</ResultData>

                <ResultData className="col col-8 md:col-6">Major Expenses Per Person</ResultData>
                <ResultData className="col col-h md:col-b md:col-2 text-right">${major}</ResultData>
                <ResultData className="col col-h md:col-b md:col-1 text-center">×</ResultData>
                <ResultData className="col col-h md:col-b md:col-2 text-center">{people}</ResultData>
                <ResultData className="col col-h md:col-b md:col-1 text-center">×</ResultData>
                <ResultData className="col col-h md:col-b md:col-1 text-center"></ResultData>
                <ResultData className="col col-h md:col-b md:col-1 text-center">=</ResultData>
                <ResultData className="col col-8 text-right md:col-2">${people * major}</ResultData>

                <ResultData className="col col-8 md:col-6">Slush Fund</ResultData>
                <ResultData className="col col-h md:col-b md:col-2 text-right">+{slush}%</ResultData>
                <ResultData className="col col-h md:col-b md:col-1 text-center">×</ResultData>
                <ResultData className="col col-h md:col-b md:col-2 text-center"></ResultData>
                <ResultData className="col col-h md:col-b md:col-1 text-center">×</ResultData>
                <ResultData className="col col-h md:col-b md:col-1 text-center"></ResultData>
                <ResultData className="col col-h md:col-b md:col-1 text-center">=</ResultData>
                <ResultData className="col col-8 text-right md:col-2">${slushCost}</ResultData>

                <ResultData className="col col-8 md:col-14 bold">TOTAL</ResultData>
                <ResultData className="col col-8 text-right md:col-2 bold">${result}</ResultData>
            </ResultAnalyticalB>
            <EmailToYourself
                handleCheckboxChange={handleCheckboxChange}
                isChecked={isChecked}
            />

            <SendEmail
                countrySelected={props.countrySelected}
                country={props.country}
                people={people}
                nights={nights}
                airfare={resAirfare}
                lodging={resLodging}
                food={resFood}
                transportation={resTrans}
                entertainment={resEnter}
                tips={resTips}
                major={resMajor}
                slush={slushCost}
                total={result}
                //siteUrl={props.siteUrl}
                //pluginUrl={props.pluginUrl}
                //thankYouPage={props.thankYouPage}
                isChecked={isChecked}
                transferData={props.transferData}
            />

        </div>
    );
}

export default FormGroup;


